<h1 class="title">
  {{ viewDate | date: "mediumDate" }}
</h1>

<div class="message-feed-container">
  <button mat-button style="margin: 5px" (click)="createMessageFeed()">
    <mat-icon>note_add</mat-icon>
  </button>
  <mat-card class="message-feed" *ngIf="messageFeeds.length == 0">
    <mat-card-content>
      <div style="font-weight: bold; font-size: medium; justify-content: end">
        Nincsen új üzenet,<br>
        további szép napot! <span [innerHTML]="emoji"></span>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="message-feed" *ngFor="let messageFeed of messageFeeds">
    <mat-card-content>
      <div style="display: flex">
        <div style="align-self: center; font-weight: bolder; font-size: 150%">
          {{ messageFeed.title }}
        </div>
          <button mat-button (click)="deleteMessageFeed(messageFeed.id)">
            <mat-icon [ngStyle]="{ color: 'red' }">delete</mat-icon>
          </button>
      </div>
      <div style="font-weight: bold; font-size: 100%">  {{ messageFeed.message }}</div>
    
      <div style="font-weight: bold; font-size: 100%">
        {{ messageFeed.user }} - {{ messageFeed.date }}
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="date"></div>
<mwl-calendar-month-view
  [locale]="locale"
  [viewDate]="viewDate"
  [events]="events"
  (dayClicked)="navigateToDayPage($event.day.date)"
  [refresh]="refresh"
  [weekStartsOn]="weekStartsOn"
>
</mwl-calendar-month-view>
<div class="buttons">
  <div class="btn-group">
    <div
      class="btn btn-primary"
      mwlCalendarPreviousView
      [view]="view"
      [(viewDate)]="viewDate"
    >
      Előző
    </div>
    <div
      class="btn btn-outline-secondary"
      mwlCalendarToday
      [(viewDate)]="viewDate"
    >
      Ma
    </div>
    <div
      class="btn btn-primary"
      mwlCalendarNextView
      [view]="view"
      [(viewDate)]="viewDate"
    >
      Következő
    </div>
  </div>
</div>
